import { render, staticRenderFns } from "./QuestionnaireItem.vue?vue&type=template&id=77507cd0&"
import script from "./QuestionnaireItem.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports